import { Col, Row } from "antd";
import { Descope, useSession } from "@descope/react-sdk";
import { useNavigate } from "react-router-dom";
import "./sign.scss";
import { useEffect } from "react";

const SignIn = () => {
  const { isAuthenticated } = useSession();
  const navigate = useNavigate();
  const flowId = "sign-up-or-in";

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);
  return (
    <div>
      <Row className="main-row">
        <Col flex="1 1 200px" className="left-container">
          <div className="sign-in-container centered">
            <Descope
              flowId={flowId}
              onSuccess={(e) => {
                navigate("/");
                console.log("Logged in!");
              }}
              onError={(e) => console.log("Error!")}
            />
          </div>
          <div></div>
        </Col>
      </Row>
    </div>
  );
};

export default SignIn;
